export default <any> {
    'berlin-city': {
        rmsid: 200528345,
    },
    'boulevard-berlin': {
        rmsid: 200576978,
    },
    'spandau': {
        rmsid: 200528532,
    },
    'berlin-mitte': {
        rmsid: 200528336,
    },
    'berlin-steglitz': {
        rmsid: 200528346,
    },
    'berlin-lp': {
        rmsid: 200576976,
    },
    'schildergasse': {
        rmsid: 200576833,
    },
    'jungfernstieg': {
        rmsid: 200580881,
    },
    'marienplatz': {
        rmsid: 200591650,
    },
    'shop-reutlingen': {
        rmsid: 200533502,
    },
    'georgstraße': {
        rmsid: 200580880,
    },
    'westenhellweg': {
        rmsid: 203327933,
    },
    'leipzig-bruehl': {
        rmsid: 200579900,
    },
    'zeil': {
        rmsid: 200528769,
    },
    'breitegasse52': {
        rmsid: 203343534,
    },
    'koenig27': {
        rmsid: 203345257,
    },
    'flinger40': {
        rmsid: 203344906,
    },
};



// WEBPACK FOOTER //
// ./app/bundles/appointman/app/ts/config/campaigns.ts